import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[portalTransclude]',
  standalone: false,
})
export class TranscludeDirective {
  @Input('portalTransclude')
  id?: string = undefined;

  get templateRef(): TemplateRef<any> {
    return this.template;
  }

  constructor(private template: TemplateRef<any>) {}
}
